import { useState, useEffect, useRef } from 'react';
import { LogOut, ChevronDown } from 'lucide-react';

export default function UserMenu({ name, onSignOut, signingOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="user-menu" ref={ref}>
      <button
        className={`user-menu-trigger${open ? ' open' : ''}`}
        onClick={() => setOpen(o => !o)}
        disabled={signingOut}
      >
        <span className="user-menu-name">{name || 'Account'}</span>
        <ChevronDown size={13} className="user-menu-chevron" />
      </button>
      {open && (
        <div className="user-menu-dropdown">
          <button
            className="user-menu-item signout"
            onClick={() => { setOpen(false); onSignOut(); }}
            disabled={signingOut}
          >
            <LogOut size={13} />
            {signingOut ? 'Signing out…' : 'Sign out'}
          </button>
        </div>
      )}
    </div>
  );
}
